import { format } from 'date-fns';
import { useRef } from 'react';
import { MdCalendarToday, MdKeyboardArrowDown, MdOutlineClose } from 'react-icons/md';
import { Button, DateRangePicker } from 'rsuite';
import { DateRangePickerProps, ValueType } from 'rsuite/lib/DateRangePicker';
import styles from './DateRangePickerCustom.module.scss';

const datePickerLocale = {
  sunday: 'Dom',
  monday: 'Seg',
  tuesday: 'Ter',
  wednesday: 'Qua',
  thursday: 'Qui',
  friday: 'Sex',
  saturday: 'Sáb',
  ok: 'OK',
  today: 'Hoje',
  yesterday: 'Ontem',
  last7Days: 'Últimos 7 dias',
  hours: 'Horas',
  minutes: 'Minutos',
  seconds: 'Segundos',
};

export const DateRangePickerCustom = ({ value, handleSelectPeriodFilter, ...props }: DateRangePickerProps) => {
  const refDateRange = useRef<DateRangePickerProps>(null);

  return (
    <div className={styles.date} data-has-value={!!value?.length}>
      <div
        className={styles['icon-container']}
        onClick={e => {
          e.stopPropagation();
          refDateRange.current?.handleOpenDropdown();
        }}
      >
        <MdCalendarToday />
      </div>
      <DateRangePicker
        block
        cleanable
        // @ts-ignore
        ref={refDateRange}
        renderValue={(value: ValueType) => {
          if (!value) return;
          if (Array.isArray(value) && value.length >= 2 && value[0] !== undefined && value[1] !== undefined) {
            return (
              <div className={styles['date-range']}>
                <span>{format(value[0], 'dd/MM/yyyy')}</span>
                {' ~ '}
                <span>{format(value[1], 'dd/MM/yyyy')}</span>
              </div>
            );
          } else {
            return null;
          }
        }}
        value={value}
        onChange={value => handleSelectPeriodFilter(value as Date[])}
        onOk={value => handleSelectPeriodFilter(value as Date[])}
        onClean={() => handleSelectPeriodFilter([])}
        appearance="default"
        placeholder="Selecione um período"
        format="DD/MM/YYYY"
        locale={datePickerLocale}
        {...props}
      />
      <div className={styles['date-range-actions']}>
        <Button appearance="link" variant="subtle" className={styles['icon-container']} data-has-value={!!value?.length}>
          <MdKeyboardArrowDown
            onClick={e => {
              e.stopPropagation();
              refDateRange.current?.handleOpenDropdown();
            }}
          />
        </Button>
        <Button appearance="link" variant="subtle" className={styles['icon-container']} data-is-visible={!!value?.length} id="clean-button">
          <MdOutlineClose
            onClick={e => {
              e.stopPropagation();
              refDateRange.current?.handleClean();
            }}
          />
        </Button>
      </div>
    </div>
  );
};
